import { render, staticRenderFns } from "./Boomerang.vue?vue&type=template&id=4d782628"
import script from "./Boomerang.vue?vue&type=script&lang=js"
export * from "./Boomerang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports